module.exports = __webpack_public_path__ + "static/media/left-menu-screens-gray.dcf51e07.svg";